import { Flex, Card, CardBody, Skeleton } from '@chakra-ui/react';
import React from 'react';

import { Typography } from 'packages/common-frontend/components/Typography';

type SummaryCardProps = {
  label: string;
  value: string;
};
export const SummaryCard = ({ label, value }: SummaryCardProps) => {
  return (
    <Card variant="outline" width="100%">
      <CardBody>
        <Flex alignItems="center" gap="1rem">
          <Flex direction="column" gap="0.5rem">
            <Typography variant="detail-muted">{label}</Typography>
            <Typography fontWeight="semibold">{value}</Typography>
          </Flex>
        </Flex>
      </CardBody>
    </Card>
  );
};

export const SkeletonCards = () => {
  return (
    <Flex mt="2.5rem" gap="1.5rem">
      <Skeleton height="5.5rem" width="100%" borderRadius="0.5rem" />
      <Skeleton height="5.5rem" width="100%" borderRadius="0.5rem" />
      <Skeleton height="5.5rem" width="100%" borderRadius="0.5rem" />
      <Skeleton height="5.5rem" width="100%" borderRadius="0.5rem" />
    </Flex>
  );
};
